<!--  -->
<template>
  <div class="firm-body">
    <!-- 主体 -->
    <div class="box">
      <div class="box-top">
        <el-form :inline="true" label-suffix="：" ref="ruleForm" :model="formInline" class="demo-form-inline">
          <el-form-item label="姓名">
            <el-input v-model="formInline.user" placeholder="请输入真实姓名"></el-input>
          </el-form-item>
          <el-form-item label="身份证号" style="margin: 0 20px">
            <el-input v-model="formInline.region" placeholder="请输入对应身份证号"></el-input>
          </el-form-item>
          <el-form-item style="margin-right: 20px">
            <el-button type="primary" @click="onSubmit" style="width: 75px; margin-left: 50px">搜索</el-button>
          </el-form-item>
          <el-form-item>
            <el-button @click="resetForm" style="color: #409eff ; border-color: #409eff ; width: 75px">重置</el-button>
          </el-form-item>
        </el-form>
      </div> 
      <div class="box-bottom">
        <el-collapse accordion @change="handleCollapseChange">
          <el-collapse-item v-for="(item, index) in listArr" :key="index" :name="item.creditId">
            <template slot="title">
              <div class="BusinessCardContent">
                <div style="width: 150px;">姓名：<span>{{ item.name }}</span></div>
                <div style="width: 240px;">身份证号：<span>{{ item.idNumber }}</span></div>
                <div style="width: 160px;">手机号：<span>{{ item.phone }}</span></div>
                <div class="OperationArea">
                  <!-- 索要联系方式：改成与精英推荐一致的微信/手机号双图标模式 -->
                  <img
                    v-if="item.idCardAndContractInfo && item.idCardAndContractInfo.eliteWechat"
                    src="@/assets/imgs/weixin@3x.svg"
                    alt=""
                    class="contact-icon firm-clickable"
                    @click.stop="showContactTip(item, true)"
                  />
                  <el-popover
                    v-else-if="item.userId || (item.idCardAndContractInfo && item.idCardAndContractInfo.userId)"
                    placement="top"
                    width="180"
                    trigger="hover"
                    popper-class="elite-contact-popover"
                  >
                    <div class="contact-popover-content">
                      <div class="contact-popover-text">确认索要对方微信号？</div>
                      <el-button
                        type="text"
                        size="mini"
                        class="contact-popover-btn"
                        @click.stop="onClickContactApply(item, true)"
                      >
                        确认
                      </el-button>
                    </div>
                    <img
                      slot="reference"
                      src="@/assets/imgs/weixin-weijiaohuan@3x.svg"
                      alt=""
                      style="margin-top: 3px;"
                      class="contact-icon"
                    />
                  </el-popover>

                  <img
                    v-if="item.idCardAndContractInfo && item.idCardAndContractInfo.elitePhone"
                    src="@/assets/imgs/dianhua@3x.svg"
                    alt=""
                    class="contact-icon firm-clickable"
                    @click.stop="showContactTip(item, false)"
                  />
                  <el-popover
                    v-else-if="item.userId || (item.idCardAndContractInfo && item.idCardAndContractInfo.userId)"
                    placement="top"
                    width="180"
                    trigger="hover"
                    popper-class="elite-contact-popover"
                  >
                    <div class="contact-popover-content">
                      <div class="contact-popover-text">确认索要对方手机号？</div>
                      <el-button
                        type="text"
                        size="mini"
                        class="contact-popover-btn"
                        @click.stop="onClickContactApply(item, false)"
                      >
                        确认
                      </el-button>
                    </div>
                    <img
                      slot="reference"
                      src="@/assets/imgs/dianhua-weijiaohuan@3x.svg"
                      alt=""
                      class="contact-icon"
                      style="margin-top: 3px;"
                    />
                  </el-popover>
                  <p class="button-p" @click.stop="goPj(item)">信用评价查看</p>
                </div>
              </div>
            </template>
            <!-- 加载中提示 -->
            <div class="text-content" v-if="resumeLoading[item.creditId] && !resumeDetail[item.creditId]" style="text-align: center; padding: 40px;">
              <i class="el-icon-loading" style="font-size: 24px; color: #409eff ;"></i>
              <div style="margin-top: 10px; color: #666; font-size: 14px;">正在加载简历...</div>
            </div>
            <!-- 加载失败提示 -->
            <!-- 失败场景也展示“暂无简历”，不再展示“加载失败”文案 -->
            <!-- 简历内容 -->
            <div class="text-content" v-if="resumeDetail[item.creditId]">
              <template v-if="isResumeEmpty(item.creditId)">
                <div class="no-resume-box">
                  <img
                    src="@/assets/imgs/no-jianli.png"
                    alt=""
                    class="work-icon"
                  />
                  <div class="no-resume-text">暂无简历</div>
                </div>
              </template>
              <template v-else>
                <div class="box-content" v-if="hasSelfEval(item.creditId)">
                  <div class="title">自我评价：</div>
                  <div class="min-size">{{ resumeDetail[item.creditId].selfEval }}</div>
                </div>

                <div class="box-content" v-if="hasUserWorkExpList(item.creditId)">
                  <p class="title">工作经历：</p>
                  <div v-for="(workItem, workIndex) in resumeDetail[item.creditId].userWorkExpList" :key="workIndex">
                    <div class="flex-box2">
                      <span style="margin-right: 40px;font-size: 16px;">{{ workItem.companyName }}</span>
                      <span>{{ workItem.startTime }} - {{ workItem.endTime }}</span>
                    </div>
                    <div class="flex-box2">
                      <span class="min-size" style="margin-right: 30px;">{{ workItem.industryTypeName }}</span>
                      <span class="min-size" style="margin-right: 30px;">{{ workItem.positionName }}</span>
                      <span class="min-size" style="margin-right: 30px;">{{ workItem.monthlyPay }}/月</span>
                    </div>
                    <div class="flex-box2">
                      <span>技能：</span>
                      <div class="jn-item" v-for="(skill, skillIndex) in workItem.skillNameList" :key="skillIndex">{{ skill }}</div>
                    </div>
                    <div>
                      <div>工作描述：</div>
                      <div style="color: #666;margin: 10px 0;">内容:</div>
                      <div v-html="workItem.jobEsc" class="min-size"></div>
                    </div>
                  </div>
                </div>
                <div class="box-content" v-if="resumeDetail[item.creditId].userProjectExpList && resumeDetail[item.creditId].userProjectExpList.length > 0">
                  <div class="title">项目经历：</div>
                  <div v-for="(projectItem, projectIndex) in resumeDetail[item.creditId].userProjectExpList" :key="projectIndex">
                    <span class="min-size" style="margin-right: 20px;"> {{ projectItem.projectName }} </span>
                    <span class="min-size" style="margin-right: 20px;"> {{ projectItem.positionName }} </span>
                    <span class="min-size"> {{ projectItem.startTime }} ~ {{ projectItem.endTime }}</span>
                    <div class="min-size">内容：</div>
                    <span class="min-size"> {{ projectItem.projectContent }}</span>
                  </div>
                </div>
                <div class="box-content" v-if="resumeDetail[item.creditId].userEducationExpList && resumeDetail[item.creditId].userEducationExpList.length > 0">
                  <p class="title">教育经历：</p>
                  <div class="flex-box2" v-for="(eduItem, eduIndex) in resumeDetail[item.creditId].userEducationExpList" :key="eduIndex">
                    <span style="margin-right: 30px;font-size: 16px;">{{ eduItem.schoolName }}</span>
                    <span style="margin-right: 30px;font-size: 16px;">{{ eduItem.xlName }}</span>
                    <span style="margin-right: 30px;font-size: 16px;">{{ eduItem.subjectName }}</span>
                    <span style="margin-right: 30px;font-size: 16px;">{{ eduItem.startTime }} - {{ eduItem.endTime }}</span>
                  </div>
                </div>
                <div class="box-content" v-if="resumeDetail[item.creditId].userCertificateList && resumeDetail[item.creditId].userCertificateList.length > 0">
                  <div class="title">证书：</div>
                  <div v-for="(certItem, certIndex) in resumeDetail[item.creditId].userCertificateList" :key="certIndex">
                    <span style="margin-right: 20px;"> {{ certItem.name }} </span>
                    <span style="margin-right: 20px;"> {{ certItem.code }} </span>
                  </div>
                </div>
              </template>
            </div>
          </el-collapse-item>
        </el-collapse>
      </div>
    </div>
    <!-- 分页 -->
    <div class="paging-box">
      <div class="paging">
        <paging :pagingObj="pagingObj" @handleCurrentChange="handleCurrentChange"></paging>
      </div>
    </div>
    <Instruction
      :EliteCard="EliteCard"
      :Credit="Credit"
      :Instruction="Instruction"
      :dialogInstruction="dialogInstruction"
      @handleCloseInstruction="dialogInstruction = false"
      @handleInstruction="handleInstruction"
    ></Instruction>
    <dialogModel :visible.sync="contactDialogVisible" :footer="false">
      <div style="padding: 20px 0">
        <div style="text-align: center" v-if="isWx">
          微信号：{{ rowObj.idCardAndContractInfo && rowObj.idCardAndContractInfo.eliteWechat
          }}<el-button
            @click="
              copyText(
                rowObj.idCardAndContractInfo &&
                  rowObj.idCardAndContractInfo.eliteWechat
              )
            "
            type="text"
            >复制</el-button
          >
          <el-button @click="handleReapplyFromCopy" type="text">重新申请</el-button>
        </div>
        <div style="text-align: center" v-else>
          手机号：{{ rowObj.idCardAndContractInfo && rowObj.idCardAndContractInfo.elitePhone
          }}<el-button
            @click="
              copyText(
                rowObj.idCardAndContractInfo &&
                  rowObj.idCardAndContractInfo.elitePhone
              )
            "
            type="text"
            >复制</el-button
          >
          <el-button @click="handleReapplyFromCopy" type="text">重新申请</el-button>
        </div>
      </div>
    </dialogModel>
  </div>
</template>

<script>
import {
  searchUserCreditEvaluation, //根据条件检索 信用评价库
  lookUserCreditEvaluationByCreditId, // 根据creditId查看信用评价
} from "../../../../assets/api/firm/HumanResources";
import * as API from "@/assets/api/firm/firmRecruit.js";
import {
  getPropCount,
  judgeCanFreeViewCreditEvaluation,
  judgeCanCommunicateElite,
} from "../../../../assets/api/firm/Opportunity";
import Instruction from "../../firmRecruit/components/Instruction.vue";
import paging from "../../../../components/paging.vue"; // 引入分页组件
export default {
  components: { paging, Instruction },
  data() {
    return {
      routeName: "",
      dialogAddress: false, // 切换地址控件
      // 工作经验索引
      experienceIndex: 0,
      //学历要求索引
      qualificationIndex: 0,
      input: "",
      dialogVisible: false,
      // 搜索表单
      formInline: {
        user: "",
        region: "",
      },

      textarea: "",
      pagingObj: {
        currentPage: 1, //当前页
        pageSize: 16, // 一页显示多少个
        totalDevice: 0, //用户总数
      }, // 屏蔽企业列表分页
      listArr: [], // 列表数据
      resumeDetail: {}, // 简历详情，使用 creditId 作为 key
      resumeLoading: {}, // 简历加载状态，使用 creditId 作为 key
      resumeError: {}, // 简历加载错误状态，使用 creditId 作为 key
      EliteCard: 0,
      Credit: 0,
      Instruction: 1,
      dialogInstruction: false,
      itemUserId: "",
      pendingCreditId: "",
      contactDialogVisible: false,
      rowObj: {},
      isWx: true,
      // 联系方式索要：精英卡弹窗确认后回调
      contactApplyPending: null,
    };
  },
  created() {
    this.routeName = this.$route.name;
    this.searchUserCreditEvaluation();
    this.getPropCountCredit();
    this.getPropCountElite();
  },
  mounted() { },
  methods: {
    getPropCountElite() {
      getPropCount({ data: 1 })
        .then((res) => {
          if (res && res.data) {
            this.EliteCard = res.data.propCount;
          }
        })
        .catch(() => {});
    },
    // 联系方式状态时间（用于判断 7 天后才能重新申请）
    getContactStatusTime(row, isWx) {
      const info = row && row.idCardAndContractInfo ? row.idCardAndContractInfo : {};
      return isWx ? info.eliteWechatStatusTime : info.elitePhoneStatusTime;
    },
    // 是否已过 7 天（未过则不允许再次申请）
    canReapplyContactByTime(row, isWx) {
      const raw = this.getContactStatusTime(row, isWx);
      if (!raw) return { ok: true };
      const t = new Date(raw);
      const ms = t.getTime();
      if (Number.isNaN(ms)) return { ok: true };
      const limitMs = ms + 7 * 24 * 60 * 60 * 1000;
      if (Date.now() >= limitMs) return { ok: true };
      return { ok: false, retryAt: new Date(limitMs) };
    },
    // 索要联系方式（微信/手机号）
    onClickContactApply(item, isWx) {
      if (!this.$checkAction || !this.$checkAction()) return;
      const can = this.canReapplyContactByTime(item, isWx);
      if (!can.ok) {
        const dt = can.retryAt;
        const mm = String(dt.getMonth() + 1).padStart(2, "0");
        const dd = String(dt.getDate()).padStart(2, "0");
        const hh = String(dt.getHours()).padStart(2, "0");
        const mi = String(dt.getMinutes()).padStart(2, "0");
        this.$tool.PromptBox(
          "warning",
          `7天内不可重复申请，请于${mm}-${dd} ${hh}:${mi}后再试`
        );
        return;
      }
      const info = item && item.idCardAndContractInfo ? item.idCardAndContractInfo : {};
      const eliteId = item.userId || info.userId;
      if (!eliteId) {
        this.$tool.PromptBox("warning", "无法识别精英信息");
        return;
      }
      const contactType = isWx ? 1 : 0; // 1微信 0电话
      judgeCanCommunicateElite({ data: { userId: eliteId } }).then((res) => {
        if (!res || res.code !== 0) return;
        const needConsumeCard = res.data === false;
        if (!needConsumeCard) {
          API.contactApply({
            data: {
              eliteId,
              contactType,
            },
          }).then((applyRes) => {
            if (applyRes && applyRes.code === 0) {
              this.$tool.PromptBox("success", "申请成功");
              this.searchUserCreditEvaluation();
              this.getPropCountElite();
            }
          });
          return;
        }
        // 需要消耗精英卡
        if (this.EliteCard > 0) {
          this.Instruction = 0;
          this.contactApplyPending = { eliteId, contactType };
          this.dialogInstruction = true;
          return;
        }
        this.$confirmWithScroll("已无可用精英卡，是否前往购买？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.$router.push("/Firm/propHire");
          })
          .catch(() => {});
      });
    },
    // 已交换：提示用户已获取联系方式
    showContactTip(item, isWx) {
      this.rowObj = item || {};
      this.isWx = isWx;
      this.contactDialogVisible = true;
    },
    copyText(textToCopy) {
      if (!textToCopy) {
        this.$tool.PromptBox("warning", "暂无可复制内容");
        return;
      }
      const textArea = document.createElement("textarea");
      textArea.value = textToCopy;
      document.body.appendChild(textArea);
      textArea.select();
      document.execCommand("copy");
      document.body.removeChild(textArea);
      this.$tool.PromptBox("success", "复制成功");
    },
    handleReapplyFromCopy() {
      const row = this.rowObj;
      const isWx = this.isWx;
      this.contactDialogVisible = false;
      this.$nextTick(() => {
        this.onClickContactApply(row, isWx);
      });
    },
    getPropCountCredit() {
      getPropCount({ data: 2 })
        .then((res) => {
          if (res && res.data) {
            this.Credit = res.data.propCount;
          }
        })
        .catch((err) => {
          console.error("获取道具数量失败：", err);
        });
    },
    resolveUserIdByCreditItem(item) {
      return new Promise((resolve) => {
        if (item.userId) {
          resolve(item.userId);
          return;
        }
        const data = { data: { creditId: item.creditId } };
        lookUserCreditEvaluationByCreditId(data).then((res) => {
          if (
            res.code == 0 &&
            res.data &&
            Array.isArray(res.data) &&
            res.data.length > 0 &&
            res.data[0].id
          ) {
            resolve(res.data[0].id);
          } else {
            resolve(null);
          }
        }).catch(() => resolve(null));
      });
    },
    handleInstruction() {
      // 精英卡：索要联系方式
      if (this.Instruction === 0) {
        const pending = this.contactApplyPending;
        this.contactApplyPending = null;
        this.dialogInstruction = false;
        this.getPropCountElite();
        if (!pending) return;
        API.contactApply({
          data: {
            eliteId: pending.eliteId,
            contactType: Number(pending.contactType),
          },
        }).then((applyRes) => {
          if (applyRes && applyRes.code === 0) {
            this.$tool.PromptBox("success", "申请成功");
            this.searchUserCreditEvaluation();
            this.getPropCountElite();
          } else {
            this.$tool.PromptBox(
              "warning",
              applyRes?.msg || applyRes?.message || "申请失败"
            );
          }
        });
        return;
      }
      // 信用卡：查看信用评价
      if (this.Instruction !== 1) return;
      this.$router.push({
        path: "/Firm/creditDetail",
        query: { key: this.pendingCreditId },
      });
      this.dialogInstruction = false;
      this.getPropCountCredit();
    },
    // ------------------ 数据列表接口
    async searchUserCreditEvaluation() {
      var data = {
        data: {
          name: this.formInline.user,
          idNumber: this.formInline.region,
        },
      };
      // 调用 接口
      const res = await searchUserCreditEvaluation(
        data,
        this.pagingObj.currentPage,
        this.pagingObj.pageSize
      );
      this.listArr = res.data.list;
      this.pagingObj.totalDevice= res.data.total
    },
    // 折叠面板展开/收起事件
    handleCollapseChange(activeNames) {
      // accordion 模式下，activeNames 是字符串（当前展开的 name）
      if (activeNames) {
        const creditId = activeNames;
        // 找到对应的 item
        const item = this.listArr.find(item => item.creditId == creditId);
        if (item) {
          this.viewResume(item);
        }
      }
    },
    // 简历为空判断（与 recruitElite/resume 页面保持一致）
    hasSelfEval(creditId) {
      const resume = this.resumeDetail && this.resumeDetail[creditId];
      const v = resume && resume.selfEval;
      return v != null && String(v).trim() !== "";
    },
    hasUserWorkExpList(creditId) {
      const resume = this.resumeDetail && this.resumeDetail[creditId];
      const list = resume && resume.userWorkExpList;
      return Array.isArray(list) && list.length > 0;
    },
    isResumeEmpty(creditId) {
      return !this.hasSelfEval(creditId) && !this.hasUserWorkExpList(creditId);
    },
    // 查看简历
    viewResume(item) {
      // 如果已经加载过，不再重复加载
      if (this.resumeDetail[item.creditId]) {
        return;
      }
      // 如果正在加载中，不重复请求
      if (this.resumeLoading[item.creditId]) {
        return;
      }
      // 清除之前的错误状态
      this.$set(this.resumeError, item.creditId, false);
      // 设置加载状态
      this.$set(this.resumeLoading, item.creditId, true);
      // 新逻辑：只依赖列表返回的 userId（无需再通过 creditId 兜底查询）
      const userId = item && item.userId ? item.userId : null;
      if (!userId) {
        // 无 userId 时也展示暂无简历（不展示“加载失败”文案）
        this.$set(this.resumeDetail, item.creditId, {
          selfEval: "",
          userWorkExpList: [],
          userProjectExpList: [],
          userEducationExpList: [],
          userCertificateList: [],
        });
        this.$set(this.resumeLoading, item.creditId, false);
        return;
      }

      const resumeData = { data: { userId } };
      API.viewEliteResume(resumeData)
        .then((resumeRes) => {
          if (resumeRes.code == 0) {
            const resumeDataItem = Array.isArray(resumeRes.data)
              ? resumeRes.data[0]
              : resumeRes.data;
            this.$set(this.resumeDetail, item.creditId, resumeDataItem);
          } else {
            // 接口返回非 0：展示暂无简历
            this.$set(this.resumeDetail, item.creditId, {
              selfEval: "",
              userWorkExpList: [],
              userProjectExpList: [],
              userEducationExpList: [],
              userCertificateList: [],
            });
          }
        })
        .catch((err) => {
          console.error("获取简历失败:", err);
          // 异常：展示暂无简历
          this.$set(this.resumeDetail, item.creditId, {
            selfEval: "",
            userWorkExpList: [],
            userProjectExpList: [],
            userEducationExpList: [],
            userCertificateList: [],
          });
        })
        .finally(() => {
          this.$set(this.resumeLoading, item.creditId, false);
        });
    },
    // 信用评价查看：仅按人才信用卡是否可免费查看放行，不前置校验是否有评价数据
    goPj(item) {
      this.Instruction = 1;
      this.pendingCreditId = item.creditId;
      // 按你的约定：judgeCanFreeViewCreditEvaluation 支持传入 creditId
      const data = { data: { creditId: item.creditId } };
      judgeCanFreeViewCreditEvaluation(data).then((res) => {
        if (res.code !== 0) {
          return;
        }
        if (res.data == false) {
          if (this.Credit > 0) {
            this.dialogInstruction = true;
          } else {
            this.$tool.PromptBox("warning", "已无可用人才信用卡，请购买");
            this.$router.push("/Firm/propHire");
          }
        } else {
          this.$router.push({
            path: "/Firm/creditDetail",
            query: { key: item.creditId },
          });
        }
      });
    },
    // 搜索
    onSubmit() {
      this.searchUserCreditEvaluation();
    },
    // 搜索栏重置
    resetForm() {
      this.formInline.user = "";
      this.formInline.region = "";
      this.searchUserCreditEvaluation();
    },
    // 分页
    handleCurrentChange(val) {
      this.pagingObj.currentPage = val;
      this.searchUserCreditEvaluation();
    },
  },
};
</script>
<style lang="less" scoped>
/deep/.el-form-item {
  margin: 0;
}
/deep/.el-form-item .el-form-item__label{
  font-size: 14px;
}
.firm-body {
  padding-bottom: 20px;
  .box {
    width: 1200px;
    min-height: 700px;

    .box-top {
      padding: 20px;
      height: 75px;
      background: #ffffff;
      box-shadow: 0px 0px 3px 0px rgba(125, 125, 125, 0.5);
      border-radius: 15px;
      box-sizing: border-box;

      .top-left {
        display: flex;
        margin: 0 0 20px 0;
        cursor: pointer;

        .text1 {
          font-size: 14px;
          color: #333300;
          font-weight: 400;
        }

        .text2 {
          font-size: 14px;
          color: #333300;
          font-weight: 400;
          margin: 0 10px;
        }

        .text2-active {
          font-size: 14px;
          color: #409eff ;
          margin: 0 10px;
          font-weight: 400;
        }
      }
    }

    .box-bottom {
      margin-top: 20px;
    }
  }
}

/deep/ .el-collapse-item__header {
  height: 60px;
  background: #ffffff;
  box-shadow: 0px 3px 5px 0px rgba(125, 125, 125, 0.5);
  border-radius: 15px;
  padding: 15px 30px;
  margin: 20px 0;
  box-sizing: border-box;
  display: flex;
  align-items: center;
}

/deep/ .el-collapse-item__arrow {
  display: none;
}

/deep/.el-collapse-item__wrap {
  overflow: hidden;
  border-radius: 0 0 20px 20px;
  width: 98%;
  margin: 0 auto;
  margin-top: -19px;
}

/deep/.el-collapse-item__content {
  padding-bottom: 0;
}

.contact-popover-content {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.contact-popover-text {
  font-size: 12px;
  color: #333;
  margin-bottom: 8px;
  line-height: 18px;
}

.contact-popover-actions {
  display: flex;
  gap: 8px;
}

/deep/ .contact-popover-btn.el-button--mini {
  padding: 5px 10px;
  font-size: 12px;
  line-height: 1;
}

/deep/.elite-contact-popover {
  padding: 10px 12px;
}

// 列表项标题样式
.BusinessCardContent {
  width: 100%;
  height: 30px;
  line-height: 30px;
  display: flex;
  align-items: center;
  font-family: PingFangSC-Medium;
  font-size: 14px;
  color: #333333;
  font-weight: 400;
  cursor: pointer;

  > div {
    display: flex;
    align-items: center;
  }

  span {
  height: 30px;
    font-size: 12px;
    color: #666666;
    margin-left: 5px;
  }

  .OperationArea {
    flex: 1;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: 12px;

    .button-p {
      width: 100px;
      height: 35px;
      line-height: 35px;
      background: #409eff ;
      border-radius: 5px;
      font-size: 12px;
      color: #ffffff;
      text-align: center;
      cursor: pointer;
    }

    .contact-icon {
      width: 24px;
      height: 24px;
      cursor: pointer;
    }
  }
}

// 简历内容样式
.text-content {
  margin: 0 auto;
  background: #F8F8F8;
  box-shadow: 0px 0px 3px 0px rgba(125, 125, 125, 0.5);
  border-radius: 0px 0px 20px 20px;
  padding: 20px;
  position: relative;
  box-sizing: border-box;

  .no-resume-box {
    padding: 40px 0;
    text-align: center;
  }

  .no-resume-text {
    font-size: 14px;
    color: #999;
  }

  .work-icon {
    width: 120px;
    display: block;
    margin: 0 auto;
  }

  .box-content {
    margin-top: 30px;

    &:first-child {
      margin-top: 0;
    }

    .title {
      font-size: 14px;
      margin: 20px 0;
      font-weight: 500;
      color: #333;
      font-family: PingFangSC-Medium;
    }

    .min-size {
      font-size: 12px;
      color: #666;
      line-height: 1.6;
    }

    .flex-box2 {
      margin: 20px 0;
      display: flex;
      align-items: center;
      flex-wrap: wrap;

      .jn-item {
        display: inline-block;
        background-color: #eee;
        margin: 0 10px;
        color: #333;
        padding: 5px;
        border-radius: 5px;
      }
    }
  }
}

// 分页
.paging-box {
  width: 100%;
  height: 22px;
  margin-top: 30px;
  display: flex;
  justify-content: flex-end;

  .paging {
    width: 90%;
    height: 100%;
    display: flex;
    justify-content: flex-end;
  }
}
</style>
